import React, { memo } from 'react'

import { InputAdornment } from '@mui/material'

import { textColor } from '../Colors'
import { textFont } from '../Fonts'
import { Text } from '../Native/Text'

type Props = {
  text: string | undefined | null
}
const TextInputAdornment = ({ text }: Props) => {
  if (text) {
    return (
      <InputAdornment position="end" variant="filled" sx={{ color: textColor, fontSize: 11, fontFamily: textFont }}>
        <Text>{text}</Text>
      </InputAdornment>
    )
  }
  return null
}

export default memo(TextInputAdornment)
